import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ImageSlider from './ImageSlider';

const ImagePost = ({ id }) => {
    const [mediaData, setMediaData] = useState(null);

    useEffect(() => {
        // Envoyez une requête HTTP GET au backend pour récupérer l'URL (ou les URLs) de l'image
        axios.get(`${process.env.REACT_APP_API_URL}/api/message/image/${id}`, { withCredentials: true })
            .then(
                response => setMediaData(response.data)
            )
            .catch(err => console.error("Failed to load post media", err));
    }, [id]);

    if (!mediaData) return <div className="loader-image-placeholder" style={{height: '200px', background: '#f3f4f6'}}></div>;

    if (Array.isArray(mediaData)) {
        return <ImageSlider images={mediaData} />;
    }

    return <img className="card-img" src={mediaData} alt="Post content" />;
};

export default ImagePost;